import { render, staticRenderFns } from "./DetailPackageRestriction.vue?vue&type=template&id=0f70c896&scoped=true"
import script from "./DetailPackageRestriction.vue?vue&type=script&lang=js"
export * from "./DetailPackageRestriction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70c896",
  null
  
)

export default component.exports